import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Routes } from '../../config/routes';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';


@Injectable({
    providedIn: 'root',
})
export class LedgerEntriesService
{
    constructor(private _http: ApplicationHttpClient) {
    }

    public generateGeneralLedgerV2(orgId: number) {
        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.AccountingV2Module.Ledger.GenerateLedger(orgId),
        );

        return this._http.post(url, this._http.serializeObject({}));
    }

    public deleteBatch(
            orgId: number,
            batchId: string
    ): Observable<void> {
        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.AccountingV2Module.Ledger.DeleteBatch(orgId, batchId)
        );

        return this._http.delete<void>(url);
    }
}
